import axios from "axios";

export function getTransferDetail(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`/distributor/admin/api/v1/transfer/${id}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
